import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import store from "./store";
import vuetify from "./plugins/vuetify";

import "@mdi/font/css/materialdesignicons.css";
Vue.use(vuetify, { iconfont: "mdi" });

import KoioteNavigationPlugin from "./plugins/navigation/KoioteNavigationPlugin";
Vue.use(KoioteNavigationPlugin);

import KoioteOmronConnectionPlugin from "./plugins/omron_connection/KoioteOmronConnectionPlugin";
Vue.use(KoioteOmronConnectionPlugin);

import KoioteSnap7ConnectionPlugin from "./plugins/snap7_connection/KoioteSnap7ConnectionPlugin";
Vue.use(KoioteSnap7ConnectionPlugin);

import KoioteImageSwitchCanvasPlugin from "./plugins/image_switch_canvas/KoioteImageSwitchCanvasPlugin";
Vue.use(KoioteImageSwitchCanvasPlugin);

import KoioteValueLabelPlugin from "./plugins/value_label/KoioteValueLabelPlugin";
Vue.use(KoioteValueLabelPlugin);

import KoioteValueLabelWritePlugin from "./plugins/value_label_write/KoioteValueLabelWritePlugin";
Vue.use(KoioteValueLabelWritePlugin);

import KoioteAutomaticValueLabelPlugin from "./plugins/automatic_value_label/KoioteAutomaticValueLabelPlugin";
Vue.use(KoioteAutomaticValueLabelPlugin);

import KoioteButtonFeedbackPlugin from "./plugins/button_feedback/KoioteButtonFeedbackPlugin";
Vue.use(KoioteButtonFeedbackPlugin);

import KoioteTankCanvasPlugin from "./plugins/tank_canvas/KoioteTankCanvasPlugin";
Vue.use(KoioteTankCanvasPlugin);

import KoioteSiloCanvasPlugin from "./plugins/silo_canvas/KoioteSiloCanvasPlugin";
Vue.use(KoioteSiloCanvasPlugin);

import QLVNAgitatorPlugin from "./plugins/agitator/QLVNAgitatorPlugin";
Vue.use(QLVNAgitatorPlugin);

import QLVNBombPlugin from "./plugins/bomb/QLVNBombPlugin";
Vue.use(QLVNBombPlugin);

import QLVNCabinetPlugin from "./plugins/cabinet/QLVNCabinetPlugin";
Vue.use(QLVNCabinetPlugin);


import KoioteLabelPlugin from "./plugins/label/KoioteLabelPlugin";
Vue.use(KoioteLabelPlugin);


import KoioteTankCanvasQuesosPlugin from "./plugins/tank_canvas_quesos/KoioteTankCanvasQuesosPlugin";
Vue.use(KoioteTankCanvasQuesosPlugin);

import KoioteBombCanvasQuesosPlugin from "./plugins/bomb_canvas/KoioteBombCanvasQuesosPlugin";
Vue.use(KoioteBombCanvasQuesosPlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
